import { render, staticRenderFns } from "./posttest.vue?vue&type=template&id=50704698&scoped=true"
import script from "./posttest.vue?vue&type=script&lang=js"
export * from "./posttest.vue?vue&type=script&lang=js"
import style0 from "./posttest.vue?vue&type=style&index=0&id=50704698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50704698",
  null
  
)

export default component.exports